export const AdmittedFilter = {
  ALL: 'ALL',
  ADMITTED: 'ADMITTED',
  NOT_ADMITTED: 'NOT_ADMITTED'
};